import React from 'react';
import Helmet from 'react-helmet';
import { useSelector } from 'react-redux';
import type { PageMeta, PageOpenGraph } from '@rcdev/api-bff-parking';

import { getBaseFonts, getFavIcons } from '../../../core/pages/sharedStatic';
import { IAppState } from '../../reducers';

type THTMLHeader = {
  isDevelopment: boolean;
  addYaTGO?: string;
};

/**
  Подключение стилей, meta и шрифтов
*/
export function HTMLHeader(props: THTMLHeader) {
  const meta = useSelector<IAppState, PageMeta | null>((state) => state.initialParameters.page?.meta || null);
  const openGraph = useSelector<IAppState, PageOpenGraph | null>(
    (state) => state.initialParameters.page?.openGraph || null,
  );
  const { isDevelopment, addYaTGO } = props;

  return (
    <Helmet>
      {meta?.title ? (<title>{meta.title}</title>) : null}
      {meta?.description ? (<meta name="description" content={meta.description} />) : null}
      {meta?.hiddenForSE ? (<meta name="robots" content="noindex" />) : null}

      {openGraph?.title ? (<meta property="og:title" content={openGraph.title} />) : null}
      {openGraph?.description ? (<meta name="og:description" content={openGraph.description} />) : null}
      {isDevelopment ? null : getFavIcons()}
      <style type="text/css">
        {
          `
          html {
            height: 100%;
          }
          body {
            height: 100%;
            margin: 0;
            background: #FAFBFB;
            font-family: 'TT Hoves Pro Variable', sans-serif;
          }
          #frontend-expired-pages {
            height: 100%;
          }
          `
        }
      </style>
      <meta name="viewport" content="width=device-width, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no" />
      {/* именно вызов функции а не как компонент */}
      {getBaseFonts()}
      {!isDevelopment &&
        <script type="text/javascript">{`
          (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
          m[i].l=1*new Date();
          for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
          k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
          (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

          ym(103283707, "init", {
            clickmap:true,
            trackLinks:true,
            accurateTrackBounce:true,
            webvisor:true
          });
        `}
        </script>}
      {!isDevelopment &&
        <noscript>{`
          <div>
            <img
              src="https://mc.yandex.ru/watch/103283707"
              style={{position: 'absolute', left: '-9999px'}}
              alt=""
            />
          </div>
        `}
        </noscript>}
      {addYaTGO === 'true' && <script src="https://yandex.ru/ads/system/context.js" async />}
    </Helmet>
  );
}
